import { bufferToHexString } from '@iotize/common/byte-converter';
import { BodyDecoder, BodyEncoder } from '@iotize/tap/client/api';

import { debug } from '../../debug';
import { MultipleMaskConverter } from './multiple-mask-decoder';
import { NumberConverter } from './number-converter';

const TAG = 'Converter';

/**
 * TODO improv it . We don't know the size of input buffer...
 */
export class UniqMaskConverter<OutputType>
  implements BodyEncoder<OutputType>, BodyDecoder<OutputType>
{
  protected _mapping: { [key: number]: OutputType };
  // protected _reverseMapping: { [key: number]: OutputType };

  constructor(mapping: any) {
    this._mapping = mapping;
  }

  public decode(body: Uint8Array): OutputType {
    return UniqMaskConverter.decodeOne(body, this._mapping);
  }

  public encode(value: OutputType): Uint8Array {
    return UniqMaskConverter.encodeOneAsBuffer(value, this._mapping);
  }

  public static decodeOneExact<OutputType>(
    data: Uint8Array | number,
    mapping: { [key: number]: OutputType },
  ): OutputType {
    if (typeof data !== 'number') {
      data = NumberConverter.fromOpaqueMsb(data);
    }
    for (var key in mapping) {
      var mask = parseInt(key);
      if (data == mask) {
        return mapping[mask];
      }
    }

    throw new Error(
      `Cannot decode ${
        typeof data === 'number'
          ? 'number ' + data
          : '0x' + bufferToHexString(data)
      }. Available keys are ${Object.keys(mapping)}`,
    );
  }

  public static decodeOne<OutputType>(
    data: Uint8Array | number,
    mapping: { [key: number]: OutputType },
  ) {
    var results = MultipleMaskConverter.decodeAll<OutputType>(data, mapping);
    if (results.length == 0) {
      throw new Error(
        `Cannot decode value ${
          typeof data === 'number' ? data : '0x' + bufferToHexString(data)
        }. Available keys are ${Object.keys(mapping)}`,
      );
    } else if (results.length > 1) {
      debug(TAG, 'Multiple result for data : ', results, data, mapping);
    }
    return results[0];
  }

  public static encodeOneAsNumber<OutputType>(
    data: OutputType,
    mapping: { [key: number]: OutputType },
  ): number {
    let swappedMap = UniqMaskConverter.swapKeyValue(mapping);
    let dataAsString = (data as any).toString();
    if (!(dataAsString in swappedMap)) {
      throw new Error(
        `Key ${dataAsString} does not exist in mapping. Available keys are ${Object.keys(
          swappedMap,
        )}`,
      );
    }
    return parseInt(swappedMap[dataAsString]);
  }

  public static encodeOneAsBuffer<OutputType>(
    data: OutputType,
    mapping: { [key: number]: OutputType },
  ): Uint8Array {
    let result = new Uint8Array(1); // TODO change according to conf
    let encodedValue = UniqMaskConverter.encodeOneAsNumber(data, mapping);
    result[0] = encodedValue & 0xff;
    return result;
  }

  public static swapKeyValue(input: { [key: string]: any }) {
    var ret: { [key: string]: any } = {};
    for (var key in input) {
      ret[input[key]] = key;
    }
    return ret;
  }
  // public static instance(){
  //     if (!StringDecoder._instance){
  //         StringDecoder._instance = new StringDecoder();
  //     }
  //     return StringDecoder._instance;
  // }
}
